import powerReviewsService from "./powerReviewsService";

// const loadProductReviewsSchema = () => {
    const schema = document.getElementById('productSchema');

    powerReviewsService.generateSchema(window.tbg.product.listId)
        .then(reviewsSchema => {
            schema.innerHTML = JSON.stringify(Object.assign(JSON.parse(schema.innerHTML), reviewsSchema));
        });;
// }
// export default loadProductReviewsSchema;